import {AreaServicio} from "./AreaServicio";
import {Colonia} from "./Colonia";
import {ServicioAdicional} from "./ServicioAdicional";
import {Sucursal} from "./Sucursal";
import {enums} from "../../enums/enums";
import {Contacto} from "./Contacto";

export interface IRecoleccion {
    paisId: number
    codigoPostal: string
    direccion: string
    colonia?: Colonia
    areaServicio?: AreaServicio
    sucursal?: Sucursal
    tipoRecoleccionId?: number
    fechaRecoleccion?: Date

    fechaCita?: Date
    fechaCitaCedis?: Date
    aceptaCita: boolean
    sinAreaServicio: boolean
    esForanea: boolean
    completado: boolean
    contacto?: any
    distribuidor?: any
    serviciosAdicionales?: ServicioAdicional[]
    tieneCruceFronterizo?: boolean,
    recalcularServicios?: boolean,
    cotizacionCitaHorario? : any,
    EsRadCitaFueraHorario?: boolean,
    RadCitaHoraDe?: string,
    RadCitaHoraHasta?: string,
    EsEadCitaFueraHorario?: boolean,
    EadCitaHoraDe?: string,
    EadCitaHoraHasta?: string,
    EsFueraHorario?: boolean,
    horaFHDe?: string,
    horaFHHasta?: string,
    EsCitaRadCedis?: boolean,
    EsCitaEadCedis?: boolean,
    esServicioInternacional?: boolean
}


export class Recoleccion {

    constructor(props: IRecoleccion) {
        Object.assign(this, props);

    }

    SetValores(solicitud, esOrigen: boolean, esCotizacion: boolean) {
        const esOcurreOrigen = esCotizacion ? solicitud.ocurreOrigen === 1 : solicitud.esOcurreOrigen === 1;
        const esOcurreDestino = esCotizacion ? solicitud.ocurreDestino === 1 : solicitud.esOcurreDestino === 1;
        const esRad = esCotizacion ? solicitud.esRAD === 1 : solicitud.esRad === 1;
        const esEad = esCotizacion ? solicitud.esEAD === 1 : solicitud.esEad === 1;

        const distribuidor = esOrigen ? solicitud.distribuidorRemitente : solicitud.distribuidorDestinatario;
        const distribuidorciudad = esOrigen ? solicitud.distribuidorRemitente?.ciudadID : solicitud.distribuidorDestinatario?.ciudadID;
        const areaServicio = esOrigen ? solicitud.areaServicioRemitente : solicitud.areaServicioDestinatario;
        const sucursal = esOrigen ? solicitud.sucursalRemitente : solicitud.sucursalDestinatario;
        const contacto = esOrigen ? solicitud.contactoRemitente : solicitud.contactoDestinatario;
        const direccion = esOrigen ? solicitud.direccionRemitente : solicitud.direccionDestinatario;
        const esOcurre = esOrigen && esOcurreOrigen || !esOrigen && esOcurreDestino;
        const recoleccionComercial = esOrigen && esRad || !esOrigen && esEad;
        const colonia = !esCotizacion? new Colonia(distribuidor?.colonium)
            : esOrigen? solicitud.coloniaOrigen: solicitud.coloniaDestino

        this.codigoPostal = distribuidor?.codigoPostal ?? "";
        this.colonia = colonia;
        this.direccion = direccion;
        this.esForanea = areaServicio != null ? areaServicio.esForanea : false;
        this.paisId = esCotizacion ? (esOrigen ? solicitud.paisIdOrigen : solicitud.paisIdDestino) : 
                                     (distribuidor?.paisID > 0 ? distribuidor?.paisID : distribuidor?.colonium?.pais?.id);
        this.esServicioInternacional = this.paisId === enums.pais.usa;
        this.aceptaCita = !this.esServicioInternacional && (esOrigen && solicitud.esRADCita || !esOrigen && solicitud.esEADCita);      
        this.serviciosAdicionales = areaServicio.serviciosAdicionales;
        this.sucursal = sucursal;
        this.completado = !esCotizacion;
        this.areaServicio = areaServicio;
        this.tipoRecoleccionId = esOcurre? enums.tipoRecoleccion.ocurre
            : recoleccionComercial? enums.tipoRecoleccion.comercial: enums.tipoRecoleccion.residencial
        if (colonia.ciudad.id === 0) {
            colonia.ciudad.id=distribuidorciudad;
        }
        if (contacto != null) {
            this.contacto =
                new Contacto({
                    id: contacto.clienteDistribuidorContactoID,
                    nombre: contacto.nombreClienteDistribuidorContacto,
                    nombreClienteDistribuidorContacto: contacto.nombreClienteDistribuidorContacto,
                    telefono: contacto.telefono,
                    correo: contacto.correo,
                    clienteDistribuidorID: contacto.clienteDistribuidorID,
                });
        }
        this.sinAreaServicio = !(solicitud.areaServicioRemitente?.id > 0) || !(solicitud.areaServicioDestinatario?.id > 0);
    }
}

export interface Recoleccion extends IRecoleccion {
}
